/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import 'moment/locale/pt';
import axios from 'axios';

import {
  Box,
  Typography,
  Grid,
  TextField,
  Button as MUIButton,
  CircularProgress,
  Modal
} from '@mui/material';
import FixedContainer from '../../../components/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PutFetch, DeleteFetch, PostFetch } from '../../../services/apiBase';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

const CprEdit = (props) => {
  dayjs.extend(utc)
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const [cprs, setCprs] = useState(null);
  const [cprYields, setCprYields] = useState([]);
  const [load, setLoad] = useState(false);
  const [openActiveCprModal, setOpenActiveCprModal] = useState(null);
  const [openCreateYieldModal, setOpenCreateYieldModal] = useState(false);
  const [newYieldModal, setNewYieldModal] = useState({
    amount_cpr_installment: 1,
    amount_cpr_profit: 1,
    business_day: 1,
    current_installment: 1,
    date_end: moment.utc(new Date()).format("YYYY-MM-DD"),
    date_start: moment.utc(new Date()).format("YYYY-MM-DD"),
    rate_cpr: 1,
    status: 'gerada',
    username: user.username,
  });
  const [openDeleteYieldModal, setOpenDeleteYieldModal] = useState(null);
  const [openUpdateAccrualModal, setOpenUpdateAccrualModal] = useState(null);

  const [validateErrors, setValidateErrors] = useState([]);
  const [datePicker, setDatePicker] = useState(null);

  const handleGetCprDetails = async (cpr_number, personne_id) => {
    const response = await GetFetch(`/financial/showCpr?cpr_number=${cpr_number}&personne_id=${personne_id}`);
    setCprs(response.data)
    if (response.data.cprs_yield.length > 0) {
      setCprYields(response.data.cprs_yield.sort((a, b) => a.current_installment > b.current_installment ? 1 : -1))
    }
  };

  useEffect(() => {
    if (!location.state) {
      return navigate('/cprf/geradas')
    } else {
      handleGetCprDetails(location.state.cpr.cpr_number, location.state.cpr.personne_id)
    }
  }, [location]);

  const handleBackHistory = () => {
    return navigate('/cprf/geradas')
  };

  // UPDATE CPRs AND YIELDS
  const handleSave = async () => {
    const valerrors =  validateData();

    if (valerrors.length > 0) {
      setValidateErrors(valerrors)
      return
    }
    setCprs(null)
    const updateCpr = createCprEntity();
    const updateYieldArray = createCprYieldEntity();

    if(updateYieldArray.length > 0) {
      updateCpr.cprs_yield = updateYieldArray
    }

    try {
      const response = await PutFetch(`/financial/institucional/cpr/${updateCpr.id}`, updateCpr)
      enqueueSnackbar('CPRF atualizada com sucesso!', { variant: 'success' });
    } catch(error) {
      console.log(error)
      enqueueSnackbar('Erro ao tentar salvar a CPRF', { variant: 'error' });
    } finally {
      handleGetCprDetails(location.state.cpr.cpr_number, location.state.cpr.personne_id)

    }
  }

  const createCprEntity = () => {
    return {
      id: cprs.id,
      amount_cpr: cprs.amount_cpr,
      amount_cpr_final: cprs.amount_cpr_final,
      brokerage_name: cprs.brokerage_name,
      business_day: cprs.business_day,
      cattle_weight_arroba: cprs.cattle_weight_arroba,
      cpr_profile: cprs.cpr_profile,
      date_end: cprs.date_end,
      date_signed: cprs.date_signed,
      date_start: cprs.date_start,
      has_pledge: cprs.has_pledge,
      instrument_type: cprs.instrument_type,
      investor_custody: cprs.investor_custody,
      price_arroba: cprs.price_arroba,
      quantity_arroba: cprs.quantity_arroba,
      rate_cpr: cprs.rate_cpr,
      register_mode: cprs.register_mode,
      type: cprs.type,
      username: user.username,
      cprs_yield: null
    }
  }

  const createCprYieldEntity = () => {
    const yieldsArray = [];
    for (const item of cprYields) {
      yieldsArray.push({
        id: item.id,
        amount_cpr_installment: item.amount_cpr_installment,
        amount_cpr_profit: item.amount_cpr_profit,
        business_day: item.business_day,
        current_installment: item.current_installment,
        date_end: item.date_end,
        date_start: item.date_start,
        payment_date: item.payment_date,
        rate_cpr: item.rate_cpr,
        status: item.status,
        username: user.username,
      })
    }
    return yieldsArray
  }

  const handleChangeCpr = async (event) => {
    const {name, value} = event.target;

    setCprs({...cprs, [name]: value})
  }

  const handleChangeDatePicker = async (fieldName, date) => {
    setCprs({...cprs, [fieldName]: dayjs(date).format('YYYY-MM-DD')})
  }

  const handleChangeYield = async (event, index) => {
    const {name, value} = event.target;

    cprYields[index][name] = value
    setCprYields(cprYields)
  }

  const handleChangeYieldDatePicker = async (fieldName, date, index) => {
    cprYields[index][fieldName] = dayjs(date).format('YYYY-MM-DD')
    setCprYields(cprYields)
  }

  // CREATE YIELD
  const handleNewYield = async (event) => {
    const {name, value} = event.target;

    setNewYieldModal({...newYieldModal, [name]: value})
  }

  const handleNewYieldDatePicker = async (fildName, date) => {
    setNewYieldModal({...newYieldModal, [fildName]: dayjs(date).format('YYYY-MM-DD')})
  }

  const handleCreateYield = async () => {
    setLoad(true)
    try {
      const response = await PostFetch(`/financial/institucional/yield/create/${cprs.id}`, newYieldModal)
      console.log(response)
      handleGetCprDetails(location.state.cpr.cpr_number, location.state.cpr.personne_id)
      enqueueSnackbar('Cupom criado com sucesso!', { variant: 'success' });
    } catch(error) {
      console.log(error)
      enqueueSnackbar('Erro ao criar cupom.', { variant: 'error' });
    } finally {
      setOpenCreateYieldModal(false)
      setLoad(false)
    }
  }

  // DELETE YIELD
  const handleDeleteYield = async () => {
    setLoad(true)
    console.log('YIELD', { openDeleteYieldModal })
    try {
      const response = await DeleteFetch(`/financial/institucional/yield/delete/${openDeleteYieldModal}`)
      console.log(response)
      handleGetCprDetails(location.state.cpr.cpr_number, location.state.cpr.personne_id)
      enqueueSnackbar('Cupom deletado com sucesso!', { variant: 'success' });
    } catch(error) {
      console.log(error);
      enqueueSnackbar('Erro ao deletar o cupom', { variant: 'error' });
    } finally {
      setLoad(false)
      setOpenDeleteYieldModal(null)
    }
  }


  // ACTIVATE CPR
  const handleActiveCPR = async (cpr_id) => {
    const valerrors =  validateData();

    if (valerrors.length > 0) {
      setValidateErrors(valerrors)
      setOpenActiveCprModal(null)
      return
    }
    setCprs(null)
    try {
      const response = await PostFetch(`/financial/institucional/cpr/activateInstitucional/${cpr_id}`)
      console.log(response)
      enqueueSnackbar('CPRF ativada com sucesso!', { variant: 'success' });
    } catch (error) {
      console.log(error)
      enqueueSnackbar('Erro ao ativar CPRF', { variant: 'error' });
    } finally {
      handleGetCprDetails(location.state.cpr.cpr_number, location.state.cpr.personne_id)
      setOpenActiveCprModal(null)
    }
  };

  const validateData = () => {
    const errors = []
    for (const cprYield of cprYields) {
      if (cprYield.rate_cpr != cprs.rate_cpr) {
        errors.push(`Cupom número ${cprYield.current_installment} possui taxa diferente da taxa da CPRF`)
      }

      if (cprYield.current_installment === 1) {
        if(moment.utc(cprYield.date_start).format("YYYY-MM-DD") !=  moment.utc(cprs.date_signed).format("YYYY-MM-DD")){
          errors.push(`A data inicial do primeiro cupom deve ser igual a data de assinatura da CPRF`)
        }
      }

      if (cprYield.current_installment === (cprYields.length)) {
        if(moment.utc(cprYield.date_end).format("YYYY-MM-DD") !=  moment.utc(cprs.date_end).format("YYYY-MM-DD")){
          errors.push(`A data final do último cupom deve ser igual a data final da CPRF`)
        }
      }

      if (typeof cprYield.current_installment != 'number') {
        errors.push(`Erro nos números dos cupons`)
      } 
    }

    const sumBusinessDayYields = cprYields.reduce(
      (acc, cprYield) => {
        return acc + Number(cprYield.business_day)
      }, 0
    );

    console.log('business days', {sumBusinessDayYields, cpr: cprs.business_day})

    if (sumBusinessDayYields != Number(cprs.business_day)) {
      errors.push(`O total de dias úteis dos cupons está diferente da CPRF`)

    }

    return errors
  }

  // UPDATE ACCRUAL
  const updateCprAccrual = async (cpr_id) => {
    setLoad(true)

    try {
      const response = await PostFetch(`/financial/institucional/cpr/updateInstitucionalCprAccrual/${cpr_id}`)
      // const response = await axios.post(`http://localhost:4600/financial/institucional/cpr/updateInstitucionalCprAccrual/3084`)
      enqueueSnackbar('Accrual atualizado com sucesso!', { variant: 'success' });
    } catch(error) {
      console.log('UPDATE ERROR')
      enqueueSnackbar('Erro ao atualizado o accrual da CPRF', { variant: 'error' });
    } finally {
      setLoad(false)
      setOpenUpdateAccrualModal(null)
    }
  }

  function getMenuButtons(status) {

    if (['gerada'].includes(status)) {
      return (
        <>
          <MUIButton
            variant="contained"
            color="success"
            sx={{ marginRight: 2 }}
            onClick={() => setOpenActiveCprModal(cprs.id)}
          >
            Ativar cpr
          </MUIButton>
        </>
      );
    }

    if (['ativa'].includes(status)) {
      return (
        <>
          <MUIButton
            variant="contained"
            color="success"
            sx={{ marginRight: 2 }}
            onClick={() => setOpenUpdateAccrualModal(cprs.id)}
          >
            Atualizar accrual
          </MUIButton>
        </>
      );
    }
  }

  return (
    <>
      {cprs ? (
        <FixedContainer>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              backgroundColor: "#F9FBFD",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              boxShadow: 3,
              borderRadius: "10px",
              padding: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
            >
              CPRF's/Editar
            </Typography>

            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
                marginBottom: 2,
              }}
            >
              <MUIButton
                variant="contained"
                color="info"
                sx={{ marginRight: 2 }}
                onClick={() => handleBackHistory()}
              >
                Voltar
              </MUIButton>

              <MUIButton
                variant="contained"
                color="success"
                sx={{ marginRight: 2 }}
                onClick={() => handleSave()}

              >
                Salvar
              </MUIButton>

              {getMenuButtons(cprs.status)}
            </Box>

            <Box
              sx={{
                marginBottom: "16px"
              }}>
              <Grid container spacing={2}>
                
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
                  >
                    Dados da CPRF
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Id da CPRF"
                      defaultValue={cprs.id}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Personne Id"
                      defaultValue={cprs.personne_id}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Número da CPRF"
                      defaultValue={cprs.cpr_number}
                      sx={{ width: "24%" }}
                    />

                    <TextField
                      id="outlined-disabled"
                      label="Tipo"
                      defaultValue={
                        cprs.type
                          ? cprs.type
                          : null
                       }
                      sx={{ width: "24%" }}
                      name="type"
                      onChange={handleChangeCpr}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 2,
                    }}
                  >
                    <DatePicker
                      label="Data da geração"
                      value={dayjs.utc(cprs.date_start)
                      }
                      name="date_start"
                      format="DD/MM/YYYY"
                      onChange={(newValue) => {
                        handleChangeDatePicker("date_start", newValue)
                      }}
                      sx={{ width: "24%" }}
                    />

                    <DatePicker
                      label="Data da ativação"
                      value={dayjs.utc(cprs.date_signed)
                      }
                      name="date_signed"
                      format="DD/MM/YYYY"
                      onChange={(newValue) => {
                        handleChangeDatePicker("date_signed", newValue)
                      }}
                      sx={{ width: "24%" }}
                    />

                    <DatePicker
                      label="Data final"
                      value={dayjs.utc(cprs.date_end)
                      }
                      name="date_end"
                      format="DD/MM/YYYY"
                      onChange={(newValue) => {
                        handleChangeDatePicker("date_end", newValue)
                      }}
                      sx={{ width: "24%" }}
                    />

                    <TextField
                      id="outlined-disabled"
                      label="Dias Úteis"
                      type="number"
                      defaultValue={
                        cprs.business_day
                        ? cprs.business_day
                        : null
                      }
                      name="business_day"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                  </Box>    
       
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      id="outlined-disabled"
                      label="Taxa(%)"
                      type="number"
                      defaultValue={
                        cprs.rate_cpr
                        ? cprs.rate_cpr
                        : null
                      }
                      name="rate_cpr"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Valor investido"
                      type="number"
                      defaultValue={
                        cprs.amount_cpr
                          ? cprs.amount_cpr
                          : null
                      }
                      name="amount_cpr"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Valor final"
                      type="number"
                      defaultValue={
                        cprs.amount_cpr_final
                          ? cprs.amount_cpr_final
                          : null
                      }
                      name="amount_cpr_final"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Status"
                      defaultValue={cprs.status ? cprs.status : "Não informado"}
                      sx={{ width: "24%" }}
                    />
                  </Box>   
                      
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 2
                  }}>
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Id Nova Futura"
                      defaultValue={cprs.nova_futura_id ? cprs.nova_futura_id : null}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Registro"
                      defaultValue={
                        cprs.register_mode
                          ? cprs.register_mode
                          : null
                      }
                      name="register_mode"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Broker"
                      defaultValue={cprs.brokerage_name ? cprs.brokerage_name : null}
                      name="brokerage_name"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Custódia"
                      defaultValue={cprs.investor_custody ? cprs.investor_custody : null}
                      name="investor_custody"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                  </Box>

                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 2
                  }}>
                    <TextField
                      id="outlined-disabled"
                      label="Instrumento"
                      defaultValue={cprs.instrument_type ? cprs.instrument_type : null}
                      name="instrument_type"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Cpr Profile"
                      defaultValue={
                        cprs.cpr_profile
                          ? cprs.cpr_profile
                          : null
                      }
                      name="cpr_profile"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Preço da arroba"
                      type="number"
                      defaultValue={cprs.price_arroba ? cprs.price_arroba : null}
                      name="price_arroba"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Quantidade de arrobas"
                      type="number"
                      defaultValue={cprs.quantity_arroba ? cprs.quantity_arroba : null}
                      name="quantity_arroba"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                  </Box>

                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 2
                  }}>
                    <TextField
                      id="outlined-disabled"
                      label="Peso por arroba"
                      type="number"
                      defaultValue={cprs.cattle_weight_arroba ? cprs.cattle_weight_arroba : null}
                      name="cattle_weight_arroba"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%" }}
                    />
                    <TextField
                      id="outlined-disabled"
                      label="Has pledge"
                      defaultValue={
                        cprs.has_pledge
                          ? cprs.has_pledge
                          : null
                      }
                      name="has_pledge"
                      onChange={handleChangeCpr}
                      sx={{ width: "24%", marginRight: "50.5%"}}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

          </Box>

          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: "18px", padding: 2 }}
          >
            Dados dos cupons
          </Typography>

          {
            cprYields.length > 0
            ? ( 
                cprYields.map((item, index) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#F9FBFD",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        boxShadow: 3,
                        borderRadius: "10px",
                        padding: 2,
                        marginTop: 2
                      }}
                    >
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
                    >
                      {`Id: ${item.id} _ ${index}`}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 2
                      }}
                    >
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Id do cupom"
                        defaultValue={item.id}
                        sx={{ width: "24%" }}
                      />
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Id da cprf"
                        defaultValue={item.cpr_id}
                        sx={{ width: "24%" }}
                      />

                      <DatePicker
                        label="Data inicial"
                        value={dayjs.utc(item.date_start)
                        }
                        name="date_start"
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          handleChangeYieldDatePicker("date_start", newValue, index)
                        }}
                        sx={{ width: "24%" }}
                      />

                      <DatePicker
                        label="Data final"
                        value={dayjs.utc(item.date_end)
                        }
                        name="date_end"
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          handleChangeYieldDatePicker("date_end", newValue, index)
                        }}
                        sx={{ width: "24%" }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 2
                      }}
                    >
                      <TextField
                        id="outlined-disabled"
                        label="Taxa"
                        type="number"
                        defaultValue={
                          item.rate_cpr
                            ? item.rate_cpr
                            : null
                          }
                        name="rate_cpr"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                      <TextField
                        id="outlined-disabled"
                        label="Dias úteis"
                        type="number"
                        defaultValue={
                          item.business_day
                            ? item.business_day
                            : null
                          }
                        name="business_day"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                      <TextField
                        id="outlined-disabled"
                        label="Número"
                        type="number"
                        defaultValue={
                          item.current_installment
                            ? item.current_installment
                            : null
                          }
                        name="current_installment"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />

                      <TextField
                        id="outlined-disabled"
                        label="Valor do cupom"
                        type="number"
                        defaultValue={
                          item.amount_cpr_installment
                            ? item.amount_cpr_installment
                            : null
                          }
                        name="amount_cpr_installment"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 2
                      }}
                    >
                      <TextField
                        id="outlined-disabled"
                        label="Valor dos juros"
                        type="number"
                        defaultValue={
                          item.amount_cpr_profit
                            ? item.amount_cpr_profit
                            : null
                          }
                        name="amount_cpr_profit"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Status"
                        defaultValue={
                          item.status
                            ? item.status
                            : null
                          }
                        name="status"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                      <DatePicker
                        label="Data de pagamento"
                        value={
                          item.payment_date 
                          ? dayjs.utc(item.payment_date)
                          : null
                        }
                        name="payment_date"
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          handleChangeYieldDatePicker("payment_date", newValue, index)
                        }}
                        sx={{ width: "24%" }}
                      />
                      

                      <TextField
                        disabled
                        id="outlined-disabled"
                        label="Usuário"
                        defaultValue={
                          item.username
                            ? item.username
                            : null
                          }
                        name="username"
                        onChange={(event) => handleChangeYield(event, index)}
                        sx={{ width: "24%" }}
                      />
                    </Box>

                    {
                      item.current_installment != 1 &&
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        marginTop: 2,
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }} 
                    >
                      <MUIButton
                        variant="contained"
                        color="error"
                        sx={{ marginRight: 2 }}
                        onClick={() => {
                         
                          setOpenDeleteYieldModal(item.id)
                        }}
                      >
                        <DeleteIcon />
                      </MUIButton>
                    </Box>
                    }

                  </Box>
                  )
                })
              )
            : (
              <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
            >
              Erro ao carregar os cupons
            </Typography>
            )
          }

          <Box
            sx={{
              width: "100%",
              height: "100%",
              padding: 2,
              marginTop: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          > 
            <MUIButton
              variant="contained"
              color="info"
              sx={{ marginRight: 2 }}
              onClick={() => {
                const [lastYield] = cprYields.sort((a, b) => a.current_installment < b.current_installment ? 1 : -1);
                const nextCurrentStalment = lastYield.current_installment + 1
                setNewYieldModal({...newYieldModal, current_installment: nextCurrentStalment})
                return setOpenCreateYieldModal(true)
              }}
            >
              Novo cupom
            </MUIButton>
          
          </Box>
                    
        </FixedContainer>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            paddingTop: 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Modal
        open={openActiveCprModal === null ? false : true}
        onClose={() => setOpenActiveCprModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            width: "100%",
            maxWidth: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: '#F9FBFD',
            padding: 3
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, fontSize: "24px", paddingBottom: 2 }}
          >
            {`Ativar cpr`}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 2
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 400, fontSize: "18px", paddingBottom: 2 }}
            >
              {`Esta é uma ação permanente, tem certeza que deseja ativar esta CPRF?
                Ao ativar a CPRF os accrual serão gerados.`}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2
            }}
          >
            <MUIButton
              variant="contained"
              color="warning"
              sx={{ marginRight: 2 }}
              onClick={() => setOpenActiveCprModal(null)}
            >
              Cancelar
            </MUIButton>

            <MUIButton
              variant="contained"
              color="success"
              onClick={() => handleActiveCPR(openActiveCprModal)}
              sx={{minWidth: '120px'}}
            >
              {
                load
                ? <CircularProgress size={'1rem'} sx={{ color: 'white' }} />
                : <>Ativar</>
              }
            </MUIButton>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openUpdateAccrualModal === null ? false : true}
        onClose={() => setOpenUpdateAccrualModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            width: "100%",
            maxWidth: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: '#F9FBFD',
            padding: 3
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, fontSize: "24px", paddingBottom: 2 }}
          >
            {`Atualizar accrual da cpr`}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 2
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 400, fontSize: "18px", paddingBottom: 2 }}
            >
              {`Esta é uma ação permanente, tem certeza que deseja atualizar os accruals desta CPRF?`}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2
            }}
          >
            <MUIButton
              variant="contained"
              color="warning"
              sx={{ marginRight: 2 }}
              onClick={() => setOpenUpdateAccrualModal(null)}
            >
              Cancelar
            </MUIButton>

            <MUIButton
              variant="contained"
              color="success"
              onClick={() => updateCprAccrual(openUpdateAccrualModal)}
              sx={{minWidth: '120px'}}
            >
              {
                load
                ? <CircularProgress size={'1rem'} sx={{ color: 'white' }} />
                : <>Atualizar</>
              }
            </MUIButton>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openCreateYieldModal}
        onClose={() => setOpenCreateYieldModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            width: "100%",
            maxWidth: "90%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: '#F9FBFD',
            padding: 3
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
          >
            {`Novo cupom`}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 2
            }}
          >
            
            <DatePicker
              label="Data inicial"
              value={
                newYieldModal.date_start
                ? dayjs.utc(newYieldModal.date_start)
                : null
              }
              name="date_start"
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                handleNewYieldDatePicker("date_start", newValue)
              }}
              sx={{ width: "24%" }}
            />

            <DatePicker
              label="Data final"
              value={
                newYieldModal.date_end
                ? dayjs.utc(newYieldModal.date_end)
                : null
              }
              name="date_end"
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                handleNewYieldDatePicker("date_end", newValue)
              }}
              sx={{ width: "24%" }}
            />

            <TextField
              id="outlined-disabled"
              label="Taxa"
              defaultValue={
                newYieldModal.rate_cpr
                  ? newYieldModal.rate_cpr
                  : null
                }
              name="rate_cpr"
              onChange={(event) => handleNewYield(event)}
              sx={{ width: "24%" }}
            />

            <TextField
              id="outlined-disabled"
              label="Dias úteis"
              defaultValue={
                newYieldModal.business_day
                  ? newYieldModal.business_day
                  : null
                }
              name="business_day"
              onChange={(event) => handleNewYield(event)}
              sx={{ width: "24%" }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 2
            }}
          >
            <TextField
              id="outlined-disabled"
              label="Número"
              defaultValue={
                newYieldModal.current_installment
                  ? newYieldModal.current_installment
                  : null
                }
              name="current_installment"
              onChange={(event) => handleNewYield(event)}
              sx={{ width: "24%", marginRight: 2 }}
            />

            <TextField
              id="outlined-disabled"
              label="Valor do cupom"
              defaultValue={
                newYieldModal.amount_cpr_installment
                  ? newYieldModal.amount_cpr_installment
                  : null
                }
              name="amount_cpr_installment"
              onChange={(event) => handleNewYield(event)}
              sx={{ width: "24%", marginRight: 2 }}
            />

            <TextField
              id="outlined-disabled"
              label="Valor dos juros"
              defaultValue={
                newYieldModal.amount_cpr_profit
                  ? newYieldModal.amount_cpr_profit
                  : null
                }
              name="amount_cpr_profit"
              onChange={(event) => handleNewYield(event)}
              sx={{ width: "24%", marginRight: 2}}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2
            }}
          >
            <MUIButton
              variant="contained"
              color="error"
              sx={{ marginRight: 2 }}
              onClick={() => setOpenCreateYieldModal(false)}
            >
              Cancelar
            </MUIButton>

            <MUIButton
              variant="contained"
              color="success"
              sx={{minWidth: '120px'}}
              onClick={handleCreateYield}
            >
              {
                load
                ? <CircularProgress size={'1rem'} sx={{ color: 'white' }} />
                : 'Criar'
              }
              
            </MUIButton>
            
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openDeleteYieldModal === null ? false : true}
        onClose={() => setOpenDeleteYieldModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            width: "100%",
            maxWidth: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: '#F9FBFD',
            padding: 3
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, fontSize: "24px", paddingBottom: 2, color: 'red' }}
          >
            {`Deletar cupom`}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: 2
            }}
          >

            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
            >
              {`Esta é uma ação permanente, tem certeza que deseja deletar esse cupom?`}
            </Typography>

          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2
            }}
          >
            <MUIButton
              variant="contained"
              color="warning"
              sx={{ marginRight: 2 }}
              onClick={() => setOpenDeleteYieldModal(null)}
            >
              Cancelar
            </MUIButton>

            <MUIButton
              variant="contained"
              color="error"
              onClick={() => handleDeleteYield()}
              sx={{minWidth: '120px'}}
            >
              {
                load
                ? <CircularProgress size={'1rem'} sx={{ color: 'white' }} />
                : <><DeleteIcon /> Deletar</>
              }
              
            </MUIButton>
            
          </Box>
        </Box>
      </Modal>

      <Modal
        open={validateErrors.length > 0 ? true : false}
        onClose={() => setValidateErrors([])}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            width: "100%",
            maxWidth: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: '#F9FBFD',
            padding: 3
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, fontSize: "24px", paddingBottom: 2, color: 'red' }}
          >
            {`Problemas encontrados`}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              marginTop: 2
            }}
          >

           {
            validateErrors.map((error, index) => (
              <Typography
                key={index}
                variant="h6"
                sx={{ fontWeight: 400, fontSize: "14px", paddingBottom: 2 }}
              >
                {`- ${error}`}
              </Typography>
            ))
           }

          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2
            }}
          >
            <MUIButton
              variant="contained"
              color="warning"
              sx={{ marginRight: 2 }}
              onClick={() => setValidateErrors([])}
            >
              Fechar
            </MUIButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CprEdit;
